import React from 'react';
import cx from 'classnames';
import {
  FormCheckbox,
  FormDatePicker,
  composeValidators,
} from 'components/common/form/FinalFormV2Elements';
import * as Validations from 'components/common/form/commonValidations';
import { FormApi } from 'final-form';
import { WeddingDetailsFormType } from '../../util/types';
import styles from '../../WeddingDetails.module.less';

type FieldSetDateProps = {
  formMutators: FormApi<WeddingDetailsFormType>;
  formValues: WeddingDetailsFormType;
};

const FieldSetDate: React.FC<FieldSetDateProps> = ({
  formMutators: { change },
  formValues: values,
}) => {
  const weddingDateValidator = (
    value: string,
    allValues: WeddingDetailsFormType
  ): undefined | string =>
    allValues.skipDate
      ? undefined
      : composeValidators(
          Validations.REQUIRED,
          Validations.DATE,
          Validations.CHECK_CURRENT_WEDDING_DATE,
          Validations.DATE_WITHIN_VALID_RANGE
        )(value, allValues);

  return (
    <>
      <div className={cx(styles.inputHeight, styles.inputSpacingHoriz)}>
        <FormDatePicker
          name="wedding_date"
          id="wedding-date__field"
          label="Wedding Date"
          customValidator={weddingDateValidator}
          calendarIcon
          disabled={values.skipDate}
          isRequired
          className={cx(styles.datePicker)}
        />
      </div>
      <FormCheckbox
        name="skipDate"
        inline
        label="We haven't decided yet."
        onChange={(): void => change('wedding_date', null)}
        className={styles.selectorButton}
      />
    </>
  );
};

export default FieldSetDate;



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/components/FieldSetDate/FieldSetDate.tsx